import React from "react";
import { useDetectAdBlock } from "../hooks/useDetectAdBlock";
export const AdBlockDetectedWrapper = ({ children, }) => {
    const adBlockDetected = useDetectAdBlock();
    return React.createElement(React.Fragment, null, adBlockDetected && children);
};
//# sourceMappingURL=AdBlockDetectedWrapper.js.map